import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity, Loader2, Eye, MousePointerClick, Heart, Route, Sparkles } from "lucide-react";

const CARDS = [
  { key: "views", label: "Zone views", icon: Eye },
  { key: "advViews", label: "Ad views", icon: Eye },
  { key: "clicks", label: "Ad clicks", icon: MousePointerClick },
  { key: "favorites", label: "Favorites", icon: Heart },
  { key: "routeOpens", label: "Route opens", icon: Route },
  { key: "engagement", label: "Engagement", icon: Sparkles },
];

export default function PlatformMetrics() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/admin/metrics/rollup").then(({ data }) => setData(data)).catch(() => setData({ platform: {}, states: [] })); }, []);

  if (!data) return <div className="rounded-2xl border border-border bg-card p-6 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>;
  const p = data.platform || {};
  const states = (data.states || []).filter((s) => (s.views + s.clicks + s.favorites + s.routeOpens + s.engagement) > 0);

  return (
    <div className="rounded-2xl border border-border bg-card p-5" data-testid="platform-metrics-widget">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-9 h-9 rounded-xl bg-cyan-500/10 flex items-center justify-center"><Activity className="w-4.5 h-4.5 text-cyan-400" /></div>
        <div>
          <h3 className="font-heading font-bold">Rider engagement</h3>
          <p className="text-xs text-muted-foreground">Live rollup: advertiser → zone → state → platform.</p>
        </div>
      </div>
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-3" data-testid="platform-metrics-cards">
        {CARDS.map(({ key, label, icon: Icon }) => (
          <div key={key} className="rounded-xl border border-border p-3 text-center">
            <Icon className="w-4 h-4 text-muted-foreground mx-auto mb-1" />
            <div className="text-lg font-heading font-bold">{(p[key] || 0).toLocaleString()}</div>
            <div className="text-[11px] text-muted-foreground">{label}</div>
          </div>
        ))}
      </div>
      {states.length > 0 && (
        <div className="mt-4">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-2">By state</div>
          <div className="divide-y divide-border" data-testid="platform-metrics-states">
            {states.slice(0, 6).map((s) => (
              <div key={s.state} className="py-2 flex items-center justify-between text-sm">
                <span className="font-medium">{s.state}</span>
                <span className="text-muted-foreground">{(s.views || 0).toLocaleString()} views · {(s.clicks || 0).toLocaleString()} clicks · {(s.favorites || 0).toLocaleString()} favs</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
